export default __webpack_public_path__ + "static/media/mfms.df126578.mp4";